import React from 'react'
import styled from 'styled-components'

const StyledHeader = styled.h1`
    font: 36px/1.2em "BrownProBold",sans-serif;
    letter-spacing: 0;
    font-weight: 500;
    line-height: 1.1em;
    position: relative;
    display: inline-block;
    color: #58585a;
    text-align: left;
    margin-left: 0.5em;
    margin-bottom: 36px;
    ::after {
        position: absolute;
        content: "";
        width: 30px;
        height: 6px;
        background-color: #e44c2a;
        top: 0.65em;
        left: -0.55em;
        margin-top: -5px;
    }
`;

const Header = ({children}) => (
 <StyledHeader>{children}</StyledHeader>
)

export default Header
